export enum StoreVersion {
  V1 = 1,
  V2 = 2,
  V3 = 3,
}
